/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationDataConnectionsDriversDriverOutputDtoMetaFromJSON, FxIdApplicationDataConnectionsDriversDriverOutputDtoMetaToJSON, } from './FxIdApplicationDataConnectionsDriversDriverOutputDtoMeta';
import { FxIdApplicationDataConnectionsDriversDriverOutputDtoStatisticsFromJSON, FxIdApplicationDataConnectionsDriversDriverOutputDtoStatisticsToJSON, } from './FxIdApplicationDataConnectionsDriversDriverOutputDtoStatistics';
/**
 * Check if a given object implements the FxIdApplicationDataConnectionsDriversDriverOutputDto interface.
 */
export function instanceOfFxIdApplicationDataConnectionsDriversDriverOutputDto(value) {
    if (!('Meta' in value) || value['Meta'] === undefined)
        return false;
    if (!('Data' in value) || value['Data'] === undefined)
        return false;
    if (!('Rows' in value) || value['Rows'] === undefined)
        return false;
    if (!('Statistics' in value) || value['Statistics'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationDataConnectionsDriversDriverOutputDtoFromJSON(json) {
    return FxIdApplicationDataConnectionsDriversDriverOutputDtoFromJSONTyped(json, false);
}
export function FxIdApplicationDataConnectionsDriversDriverOutputDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Meta': (json['Meta'].map(FxIdApplicationDataConnectionsDriversDriverOutputDtoMetaFromJSON)),
        'Data': json['Data'],
        'Rows': json['Rows'],
        'Statistics': FxIdApplicationDataConnectionsDriversDriverOutputDtoStatisticsFromJSON(json['Statistics']),
    };
}
export function FxIdApplicationDataConnectionsDriversDriverOutputDtoToJSON(json) {
    return FxIdApplicationDataConnectionsDriversDriverOutputDtoToJSONTyped(json, false);
}
export function FxIdApplicationDataConnectionsDriversDriverOutputDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Meta': (value['Meta'].map(FxIdApplicationDataConnectionsDriversDriverOutputDtoMetaToJSON)),
        'Data': value['Data'],
        'Rows': value['Rows'],
        'Statistics': FxIdApplicationDataConnectionsDriversDriverOutputDtoStatisticsToJSON(value['Statistics']),
    };
}
//# sourceMappingURL=FxIdApplicationDataConnectionsDriversDriverOutputDto.js.map